import React from 'react'

import CustomerRoutes from 'features/customers/routes'
import EnrichRoutes from 'features/enrich/routes'
import RevealRoutes from 'features/reveal/routes'
import { Navigate, Route, Routes } from 'react-router-dom'
import { UrlProvider } from 'urls'

import NameToDomainRoutes from 'routes/NameToDomainRoutes'

import AuthRoutes from './AuthRoutes'
import CampaignRoutes from './CampaignRoutes'
import CompanyRoutes from './CompanyRoutes'
import DataChangeRequests from './DataChangeRequestRoutes'
import UsersRoutes from './UserRoutes'

const Routing = () => (
  <Routes>
    <Route element={<Navigate replace to={UrlProvider.getUrl('customers')} />} path="/" />
    {AuthRoutes}
    {CampaignRoutes}
    {CompanyRoutes}
    {CustomerRoutes}
    {UsersRoutes}
    {DataChangeRequests}
    {NameToDomainRoutes}
    {RevealRoutes}
    {EnrichRoutes}
    <Route element={<Navigate replace to="/" />} path="*" />
  </Routes>
)

export default <Routing />
